import { graphql } from 'gatsby'
import React from 'react'
import { Gallery } from 'react-photoswipe-gallery'

import { ImageViewModal } from '@/components/image/image-view-modal'
import Player from '@/components/video/player/player'
import { ViewModal } from '@/components/view-modal/view-modal'

import * as styles from './media-gallery.module.scss'

const MediaGalleryWrapper: React.FC<Queries.MediaGalleryFragment> = (props) => {
  const { title, items } = props

  return (
    <div className="container">
      <div className="row mt-4">
        <div className="col">
          <h2>{title}</h2>
        </div>
      </div>
      <Gallery>
        <div className="row items mt-2">
          {items?.map((item) => {
            if (item === undefined || item === null) return <></>
            if (item?.__typename === 'DatoCmsAssetsCollection') {
              const assetsCollection = item.items
              return assetsCollection?.map((asset) => {
                if (asset.isImage === true) {
                  return (
                    <div
                      className={`col-lg-4 col-sm-6 mb-4 mt-lg-0 ${styles.imageBox}`}
                      key={asset.originalId}
                    >
                      <ImageViewModal
                        image={{
                          alt: asset.alt,
                          fluid: asset.fluid
                        }}
                        fullImage={{
                          alt: asset.alt,
                          fluid: asset.fullImageFluid
                        }}
                      />
                    </div>
                  )
                } else {
                  const imageThumb = asset?.video?.thumbnailUrl
                    ? asset?.video?.thumbnailUrl +
                      '?width=450&height=300&fit_mode=crop'
                    : ''
                  return (
                    <div
                      key={asset.originalId}
                      className={`col-lg-4 col-sm-6 mb-4 mt-lg-0 ${styles.imageBox}`}
                    >
                      <ViewModal
                        content={
                          <Player
                            video={asset?.video?.mp4Url}
                            autoPlay={true}
                            preview={null}
                          />
                        }
                        preview={
                          <span className={styles.playVideo}>
                            <img
                              src={imageThumb}
                              alt={asset?.title ?? ''}
                              style={{
                                cursor: 'pointer',
                                objectFit: 'contain',
                                width: '100%',
                                maxHeight: '100%'
                              }}
                            />
                          </span>
                        }
                      />
                    </div>
                  )
                }
              })
            } else if (item?.__typename === 'DatoCmsVideo') {
              return (
                <div
                  className="col-lg-3 col-sm-6 mb-4 mt-lg-0"
                  key={item?.video?.providerUid}
                >
                  <ViewModal
                    content={
                      <Player
                        video={item?.video?.url}
                        autoPlay={true}
                        preview={null}
                      />
                    }
                    preview={
                      <span className={styles.playVideo}>
                        <img
                          src={item?.video?.thumbnailUrl ?? ''}
                          alt={item?.video?.title ?? ''}
                          style={{
                            cursor: 'pointer',
                            objectFit: 'contain',
                            width: '100%',
                            maxHeight: '100%'
                          }}
                        />
                      </span>
                    }
                  />
                  <div className={styles.captionVideo}>
                    {item?.video?.title}
                  </div>
                </div>
              )
            }
          })}
        </div>
      </Gallery>
    </div>
  )
}

export default MediaGalleryWrapper

export const query = graphql`
  fragment MediaGallery on DatoCmsMediaGallery {
    __typename
    id
    title
    items {
      __typename
      ... on DatoCmsAssetsCollection {
        items {
          originalId
          isImage
          alt
          title
          video {
            thumbnailUrl
            mp4Url
          }
          fluid(
            imgixParams: { w: "450", h: "300", fit: "crop", crop: "faces" }
          ) {
            src
          }
          fullImageFluid: fluid(imgixParams: { w: "1800" }) {
            src
            srcSet
            height
            width
          }
        }
      }
      ... on DatoCmsVideo {
        video {
          providerUid
          url
          title
          thumbnailUrl
          width
          height
        }
      }
    }
  }
`
